const env = {
  BASE_URL: process.env.REACT_APP_API_URL || "http://localhost:3000",
  API_URL:
    `${process.env.REACT_APP_API_URL}/api` || "http://localhost:8000/api",
  RECAPCHA_SITEKEY: process.env.REACT_APP_RECAPTCHA_SITEKEY,
  FACEMATCH_URL: process.env.REACT_APP_FACE_MATCH_URL,
  API_REPORT_URL: process.env.REACT_APP_API_REPORT,
  ENCRYPTION_KEY: process.env.REACT_APP_ENCRYPTION_KEY,
  MINIO_BASE_URL: process.env.REACT_APP_MINIO_BASE_URL,
};

export { env };
